import React from 'react'
import { Input, InputPassword, Label } from '../input/input'
import { SubmitButton } from '../input/button'
import './style.css'

export const LoginForm = ({
  forms,
  setForm,
  handleSignIn,
  loading,
  loadingText,
  wrongPass,
  error,
  onKeyDown,
}) => (
  <div className="form-container">
    <h2 className="signin-title">Iniciar sesión</h2>
    <form className="signin-form" onKeyDown={onKeyDown}>
      <div className="form-group">
        <Label value="Correo electrónico" />
        <Input
          type="email"
          id="signInEmailField"
          placeholder="correo@ejemplo.com"
          useRef={forms}
        />
      </div>
      <div className="form-group">
        <Label value="Contraseña" />
        <InputPassword
          type="password"
          id="signInPasswordField"
          useRef={forms}
          placeholder="***********"
        />
      </div>
      {wrongPass && <p className="error-text">{error}</p>}
      <SubmitButton
        text="Ingresar"
        onClick={handleSignIn}
        onKeyPress={onKeyDown}
        loading={loading}
        type="button"
        loadingText={loadingText || 'Validando credenciales...'}
      />
    </form>
    <div className="recover-text">
      ¿Olvidaste tu contraseña?{' '}
      <span className="signin-recover-text" onClick={() => setForm('forgotPassword')}>
        Recupérala aquí
      </span>
    </div>
  </div>
)
